import toast from 'react-hot-toast';

const createErrorToast = (message) => {
  toast.error(message, {
    position: 'top-right',
  })
}

const createInfoToast = (message) => {
  toast(message, {
    position: 'top-right',
    icon: '⚠️',
  })
}


export {createErrorToast, createInfoToast}